import { images } from "helpers/images";
const PopupThankYouUI = ({ Heading, SubHeading }) => {
  return (
    <div className="flex flex-col w-full items-center justify-center  py-8">
      <img
        src={images.feedbackThankYou}
        alt="thank-you-image"
        className={`w-[80%] lg:w-[60%] !max-w-[330px] aspect-square`}
      />
      <div className="flex flex-col w-full justify-center items-center gap-4">
        <div className="flex flex-col justify-center items-center gap-3">
          <p className="text-2xl font-bold">{Heading}</p>
          <p className="text-base font-medium text-grey-700 text-center">{SubHeading}</p>
        </div>
      </div>
    </div>
  );
};

export default PopupThankYouUI;
